import styled, { css } from 'styled-components';

import { ReactComponent as CloseIcon } from '@pkg/assets/icons/v2/close.svg';

export const DepActionsGroup = styled.div`
    && {
        // TODO: This should be converted to a
        // <Drawer.Actions /> component.
        display: flex;
        width: 100%;
        gap: 10px;
    }
`;

export const DepChipText = styled.p`
    margin: 0;
    font-family: 'Alliance No.1';
    font-size: 12px;
    font-weight: 700;
    text-transform: capitalize;
    white-space: nowrap;
    color: white;
`;

export const DepClearAll = styled.p`
    cursor: pointer;
    margin: 0;
    padding-right: 20px;
    font-family: 'Alliance No.1';
    font-size: 14px;
    font-weight: 400;
    text-decoration: underline;
    white-space: nowrap;
    color: white;
    opacity: 0.5;

    &:hover {
        opacity: 0.7;
    }
`;

export const DepClose = styled(CloseIcon)`
    && {
        width: 10px !important;
        min-width: 10px !important;
    }
`;

export const DepHoverContainer = styled.div`
    position: relative;
`;

export const DepUnderline = styled.div<{ $hovering: boolean }>`
    height: 2px;
    width: 100%;
    background-color: #fff;
    position: absolute;
    top: 100%;
    left: 1px;

    transform: scaleX(0);
    transform-origin: right 0;
    transition: transform 300ms ease;

    ${({ $hovering }) =>
        $hovering
            ? css`
                  transform: scaleX(1);
                  transform-origin: 0 0;
              `
            : null}

    display: none;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        display: block;
    }
`;

const INPUT_BASE = css`
    background-color: transparent;
    border: none;
    outline: none;
    margin: 0;
    padding: 0;
    width: 100%;
    cursor: text;
    font: inherit;
    color: inherit;
    caret-color: ${({ theme }) => theme.colors.purple};

    &:focus {
        border: none;
    }

    &::placeholder {
        color: rgb(255, 255, 255, 0.2);
    }
`;

export const DepStyledInput = styled.input`
    display: flex;

    ${INPUT_BASE};

    padding: 20px;
    width: 100%;
    background: rgb(255, 255, 255, 0.04);

    &::placeholder {
        color: rgb(255, 255, 255, 0.5);
    }
`;

export const DepStyledSelect = styled.select`
    border-radius: 8px;
    background: none;
    min-width: 200px;
    display: block;
    padding: 4px;
    color: rgb(255, 255, 255, 0.5);
`;
